// Import icons first
import errorSvg from './error.svg';
import lockSvg from './lock.svg';
import sendSvg from './send.svg';

// Import project images
import BloodLinkKeyImg from './bloodlink/key.png';
import InsightMinerKeyImg from './insight-miner/key.png';
import EarthquakeKeyImg from './earthquake/key.png';
import DiamondSalonKeyImg from './daimond-salon/key.png';

// Export icons
export {
    errorSvg as ErrorIcon,
    lockSvg as LockIcon,
    sendSvg as SendIcon
};

// Export project images
export const BloodLinkKey = BloodLinkKeyImg;
export const InsightMinerThumb = InsightMinerKeyImg;
export const EiraThumb = EarthquakeKeyImg;
export const DiamondSalonKey = DiamondSalonKeyImg;